import React from "react";
import { IconButton } from "@mui/material";

import Tooltip from "@mui/material/Tooltip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

type Props = {
  info: string;
};

const InfoMsg = ({ info }: Props) => {
  return (
    <Tooltip title={info} placement="top-start" arrow>
    <IconButton
      aria-label="info"
      size="medium"
      style={{ padding: "0 0 0 5px" }}
    >
      <HelpOutlineIcon fontSize="medium" />
    </IconButton>
    </Tooltip>
  );
};

export default InfoMsg;
